export default "__VITE_ASSET__BV1QVIPe__"